import React from 'react';
import { Flex, Button, Box } from 'rebass';
import styled from 'styled-components';
import colors from 'theme/colors';

const NavButtonWrapper = styled(Flex)<any>`
  #navButtonHover {
    visibility: ${props => props.active && 'visible'};
  }
`;
const NavButtonHover = styled(Box)`
  background: ${colors.turquoise};
  height: 10px;
  border-radius: 5px;
  visibility: hidden;
`;

const NavButton: React.FC<any> = ({ title, clickHandler, active }): JSX.Element => (
  <NavButtonWrapper flexDirection="column" active={active}>
    <Button variant="navigation" onClick={clickHandler}>
      {title}
    </Button>
    <NavButtonHover id="navButtonHover" />
  </NavButtonWrapper>
);

export default NavButton;
